import { Grid, Paper, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "../../controls";
import { Form } from "../../layout";
import { Model, UseForm } from "../../hooks";
import { useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { controller, endpoints } from "../../api/actions/api";
import * as actions from "../../api/actions/pos";
import {
  IsEmptyObj,
  RmvEmptyProp,
  RmvNullProp,
  ToFormData,
} from "../../hooks/Method";
import { useEffect } from "react";
import { useState } from "react";

const AddEditSplr = (props) => {
  const { t } = useTranslation();
  const { _post, _put, _data, _clear, _type, _getById, _authUser, _store } =
    props;
  const { SuppliersMdl } = Model();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const isAddMode = !id;

  const { values, setValues, errors, setErrors, handleInpChg } =
    UseForm(SuppliersMdl);

  const validateForm = () => {
    let temp = {};

    temp.firstName =
      values.firstName !== "" ? "" : t("firstNameRequired");

    temp.lastName =
      values.lastName !== "" ? "" : t("lastNameRequired");

    temp.phone =
      values.phone !== "" ? "" : t("phoneRequired");

    temp.company =
      values.company !== "" ? "" : t("companyNameRequired");

    temp.email =
      values.email !== ""
        ? /^$|.+@.+..+/.test(values.email)
          ? ""
          : t("invalidEmail")
        : t("emailRequired");

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = () => {
        setLoading(false);
        _getById(
          endpoints.Supplier + controller.GetByStore,
          _store.id,
          actions.ActionType.List,
          navigate("/suppliers")
        );
      };
      values.userId = _authUser.id;
      // Call Api
      if (isAddMode) {
        // Add supllier form data must have storeId to link supplier with store, 
        // so adding storeId in values before sending to api
        values.storeId = _store.id;
        _post(
          endpoints.Supplier,
          ToFormData(RmvEmptyProp(values)),
          null,
          onComplete
        );
      } else {
        // update supplier form data must have supplier id to update the specific supplier,
        // so adding id in values before sending to api
        values.id = id;
        _put(
          endpoints.Supplier,
          ToFormData(RmvEmptyProp(values)),
          null,
          onComplete
        );
      }
    }
  };

  useEffect(() => {
    // Get Product Data By Product-Id
    if (!isAddMode) {
      _getById(
        endpoints.Supplier + controller.GetById,
        id,
        actions.ActionType.Data
      );
    }

    return () => {
      _clear();
      _clear({}, actions.ActionType.ClearData);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    // Set Update Values
    if (!isAddMode && !IsEmptyObj(_data) && _type === "supplier")
      setValues({ ...values, ...RmvNullProp(_data) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_data]);

  return (
    <>
      <Paper className="mt-30 shadow-xs br-8">
        <Form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={3} className="p-20 pt-0">
            <Grid item xs={12} className="tx-center mt-20">
              <Typography variant="h5" className="fs-22 gray-color fw-5 tx-upp">
                {isAddMode ? t("addSupplier") : t("updateSupplier")}
              </Typography>
              <div className="bs-bottom mx-w-80 m-auto mt-10 mb-30" />
            </Grid>
            <Grid item xs={12}>
              <Input
                label={t("companyName")}
                name="company"
                value={values.company}
                error={errors.company}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 500 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("firstName")}
                name="firstName"
                value={values.firstName}
                error={errors.firstName}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 200 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("lastName")}
                name="lastName"
                value={values.lastName}
                error={errors.lastName}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 200 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("email")}
                name="email"
                value={values.email}
                error={errors.email}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 350 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label={t("phone")}
                name="phone"
                value={values.phone}
                error={errors.phone}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 200 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label={t("productsSale")}
                name="productSale"
                value={values.productSale}
                error={errors.productSale}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 800 }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label={t("city")}
                name="city"
                value={values.city}
                error={errors.city}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 400 }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label={t("state")}
                name="state"
                value={values.state}
                error={errors.state}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 400 }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label={t("zip")}
                name="zip"
                value={values.zip}
                error={errors.zip}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 300 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label={t("address")}
                name="address"
                value={values.address}
                error={errors.address}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 800 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label={t("note")}
                name="note"
                multiline
                rows={2}
                value={values.note}
                error={errors.note}
                onChange={handleInpChg}
                fullWidth
                inputProps={{ maxLength: 1000 }}
              />
            </Grid>
            <Grid item xs={12} className="tx-right">
              <Button
                loading={loading}
                type="submit"
                sx={{ width: { md: "150px", xs: "100%" } }}
                size="large"
              >
                {isAddMode ? t("submit") : t("saveChanges")}
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Paper>
    </>
  );
};

const mapStateToProps = (state) => ({
  _data: state.pos.data,
  _type: state.pos.type,
  _authUser: state.pos.authUser,
  _store: state.pos.defStore,
});

const mapActionToProps = {
  _post: actions.post,
  _put: actions.put,
  _getById: actions.getById,
  _clear: actions.clear,
};

export default connect(mapStateToProps, mapActionToProps)(AddEditSplr);
